import React from 'react';
import { Chip } from '@mui/material';

interface GaugeChipProps {
  gauge: string;
  size?: 'small' | 'medium';
}

const GaugeChip: React.FC<GaugeChipProps> = ({ gauge, size = 'small' }) => {
  // Match colors from DiaCircle component
  // 14 GG: sky blue (#90caf9), 16 GG: cyan/teal (#00acc1), 24 GG: coral/salmon (#ff9e80)
  const getBackgroundColor = () => {
    switch (gauge) {
      case '14':
        return '#90caf9'; // Sky blue
      case '16':
        return '#00acc1'; // Cyan/teal
      case '24':
        return '#ff9e80'; // Coral/salmon
      default:
        return '#90caf9'; // Default to sky blue
    }
  };

  return (
    <Chip
      label={`${gauge} GG`}
      size={size}
      sx={{
        bgcolor: getBackgroundColor(),
        color: '#fff',
        fontWeight: 'medium',
      }}
    />
  );
};

export default GaugeChip;


